import { buildCompactStatementRow } from './sharedRowFields';

export const adaptBillingSearchStatement = (statement) => {
    return buildCompactStatementRow({
        statement,
        transaction: statement.Transaction,
        extra: {
            JobFeeAmount: statement.JobFeeAmount,
            JobFeeAmountDef: statement.JobFeeAmountDef,
        },
    });
};

export const adaptBillingSearchStatements = (statements = []) => {
    return statements.map(adaptBillingSearchStatement);
};
